<div class="drp-cal-header">
  <button mat-icon-button (click)="previousClicked()" class="drp-cal-header-arrow">
   <i class="far fa-arrow-left"></i>
  </button>

  <div class="drp-cal-header-center">
    <button
      mat-button
      class="drp-cal-header-part drp-cal-header-month"
      (click)="monthClicked()">
      {{ monthLabel }}
    </button>

    <span class="drp-cal-header-divider"></span>

    <button
      mat-button
      class="drp-cal-header-part drp-cal-header-year"
      (click)="yearClicked()">
      {{ yearLabel }}
    </button>
  </div>

  <button mat-icon-button (click)="nextClicked()" class="drp-cal-header-arrow">
    <i class="far fa-arrow-right"></i>
  </button>
</div>
